<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}">
</ngx-loading>
<div class="wrapper">
    <app-sidebar></app-sidebar>
    <app-header></app-header>
    <div class="page-wrapper">
        <div class="page-content">
            <!--breadcrumb-->
            <div class="page-breadcrumb d-none d-sm-flex align-items-center mb-4">
                <div class="breadcrumb-title pe-3" *ngIf="CurrentUrl=='/my-report'">My Reports</div>
                <div class="breadcrumb-title pe-3" *ngIf="CurrentUrl=='/report-user'">Report User</div>
                <div class="breadcrumb-title pe-3" *ngIf="CurrentUrl=='/report-post'">Report Post</div>
                <div class="breadcrumb-title pe-3" *ngIf="CurrentUrl=='/report-comment'">Report Comment</div>
                <div class="breadcrumb-title pe-3" *ngIf="CurrentUrl=='/feedback'">Feedback</div>
                <div class="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0 p-0">
                            <li class="breadcrumb-item"><a href="javascript:void(0)" routerLink="/dashboard"><i class="bx bx-home-alt"></i></a>
                            </li>
                            <li class="breadcrumb-item active text-capitalize" aria-current="page" *ngIf="CurrentUrl=='/my-report'" (click)="service.back()">{{userNames}}</li>
                            <li class="breadcrumb-item active" aria-current="page" *ngIf="CurrentUrl=='/report-user'">Report User</li>
                            <li class="breadcrumb-item active" aria-current="page" *ngIf="CurrentUrl=='/report-post'">Report Post</li>
                            <li class="breadcrumb-item active" aria-current="page" *ngIf="CurrentUrl=='/report-comment'">Report Comment</li>

                            <li class="breadcrumb-item active text-capitalize" aria-current="page" *ngIf="CurrentUrl=='/feedback'">Feedback</li>
                        </ol>
                    </nav>
                </div>

                <div class="ms-auto">
                    <div class="btn-group ms-2" role="group">

                    </div>
                </div>
            </div>
            <!--end breadcrumb-->

            <div class="row align-items-end">
                <div class="col-12" *ngIf="CurrentUrl=='/report-user'">
                    <div class="card">
                        <div class="card-body  table-responsive">
                            <table class="table mb-0 table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">No.</th>
                                        <th scope="col">Reported To</th>
                                        <th scope="col">Reported By</th>
                                        <th scope="col">Report Reason</th>
                                        <th scope="col">Date</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody *ngIf="dataListing.length !=0">
                                    <tr *ngFor="let item of dataListing | paginate: { itemsPerPage: pageLimit, currentPage: p, totalItems: totalCount}; let i = index ">
                                        <td scope="row">{{(pageLimit * (p - 1)) + i + 1 }}</td>
                                        <td> {{item.matchData.fullName}} </td>
                                        <td>{{item.userData.fullName}} </td>
                                        <td>{{item.reason}}</td>
                                        <td>{{service.dateCon(item.createdAt)}}
                                        <td>
                                            <div class="box-btn" *ngIf="item.status =='Approved'">
                                                <button type="button" title="Approve" class="btn btn-primary text-center" >
                                                    Approved
                                                </button>
                                            </div>
                                            <!-- <div class="box-btn" *ngIf="item.status =='Approved'">
                                                <button type="button" title="Approve" class="btn btn-primary text-center" >
                                                    Approved
                                                </button>
                                            </div> -->
                                            <div class="box-btn" *ngIf="item.status !='Approved'">
                                                <button type="button" title="Approve" class="btn btn-info text-center me-2" (click)="approve(item._id,1)">
                                                    Approve
                                                </button>
                                                <button type="button" title="Ignore" class="btn btn-danger text-center" (click)="reject(item._id,1)">
                                                    Ignore
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody *ngIf="dataListing.length ==0">
                                    <tr>
                                        <p class="text-center">Sorry, No Record Found</p>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="pagination-block pt-5">
                                <pagination-controls [previousLabel]="previousLabel" [nextLabel]="nextLabel" (pageChange)="getDetail((p = $event))" class="text-center" *ngIf="dataListing.length > 0"></pagination-controls>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="col-12" *ngIf="CurrentUrl=='/report-post'">
                    <div class="card">
                        <div class="card-body  table-responsive">
                            <table class="table mb-0 table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">No.</th>
                                        <th scope="col">Reported To</th>
                                        <th scope="col">Reported By</th>
                                        <th scope="col">Report Reason</th>
                                        <th scope="col">Post</th>
                                        <th scope="col">Description</th>
                                        <th scope="col">Date</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody *ngIf="dataListing.length !=0">
                                    <tr *ngFor="let item of dataListing | paginate: { itemsPerPage: pageLimit, currentPage: p, totalItems: totalCount}; let i = index ">
                                        <td scope="row">{{(pageLimit * (p - 1)) + i + 1 }}</td>
                                        <td> {{item.postOwnerData.firstName}} {{item.postOwnerData.lastName}}</td>
                                        <td>{{item.userData.firstName}} {{item.userData.lastName}}</td>
                                        <td [title]="item.reason">{{item.reason | truncate:20}}</td>
                                        <td *ngIf="item.postData.type==1"> <video [src]="item.postData.content"  disablePictureInPicture controlsList="noplaybackrate nodownload" type="video/*" style="height: 70px;width:70px" (click)="largeView=item.postData.content" data-bs-toggle="modal" data-bs-target="#Video_view1"></video>
                                        <td *ngIf="item.postData.type==2"><img [src]="item.postData.content" style="height: 70px;width:70px;cursor: pointer;" (click)="largeView =item.postData.content" data-bs-toggle="modal" data-bs-target="#Image_view1"></td>
                                        <td [title]="item.postData.description">{{item.postData.description | truncate:20}}
                                        </td>
                                        <td>{{service.dateCon(item.createdAt)}}
                                        </td>
                                        <td>
                                            <div class="box-btn" *ngIf="item.status =='Approved'">
                                                <button type="button" title="Approve" class="btn btn-primary text-center" >
                                                    Approved
                                                </button>
                                            </div>
                                            <div class="box-btn" *ngIf="item.status !='Approved'">
                                                <button type="button" title="Approve" class="btn btn-info text-center" (click)="approve(item._id,2)">
                                                    Approve
                                                </button>
                                            </div>
                                        </td>
                                    </tr>

                                </tbody>
                                <tbody *ngIf="dataListing.length ==0">
                                    <tr>
                                        <p class="text-center">Sorry, No Record Found</p>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="pagination-block pt-5">
                                <pagination-controls [previousLabel]="previousLabel" [nextLabel]="nextLabel" (pageChange)="getDetail((p = $event))" class="text-center" *ngIf="dataListing.length > 0"></pagination-controls>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12" *ngIf="CurrentUrl=='/report-comment'">
                    <div class="card">
                        <div class="card-body  table-responsive">
                            <table class="table mb-0 table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">No.</th>
                                        <th scope="col">Reported To</th>
                                        <th scope="col">Reported By</th>
                                        <th scope="col">Report Reason</th>
                                        <th scope="col">Comment</th>
                                        <th scope="col">Post</th>
                                        <th scope="col">Date</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody *ngIf="dataListing.length !=0">
                                    <tr *ngFor="let item of dataListing | paginate: { itemsPerPage: pageLimit, currentPage: p, totalItems: totalCount}; let i = index ">
                                        <td scope="row">{{(pageLimit * (p - 1)) + i + 1 }}</td>
                                        <td> {{item.postOwnerData.firstName}} {{item.postOwnerData.lastName}}</td>
                                        <td>{{item.userData.firstName}} {{item.userData.lastName}}</td>
                                        <td>{{item.reason}}</td>
                                        <td [title]="item.postCommentData.comment">{{item.postCommentData.comment | truncate:30}}</td>
                                        <td *ngIf="item.postData.type==1"> <video [src]="item.postData.content"  disablePictureInPicture controlsList="noplaybackrate nodownload" type="video/*" style="height: 70px;width:70px" (click)="largeView=item.postData.content" data-bs-toggle="modal" data-bs-target="#Video_view1"></video>
                                        <td *ngIf="item.postData.type==2"><img [src]="item.postData.content" style="height: 70px;width:70px;cursor: pointer;" (click)="largeView =item.postData.content" data-bs-toggle="modal" data-bs-target="#Image_view1"></td>
                                        <td>{{service.dateCon(item.createdAt)}}
                                        </td>
                                        <td>
                                            <div class="box-btn" *ngIf="item.status =='Approved'">
                                                <button type="button" title="Approve" class="btn btn-primary text-center" >
                                                    Approved
                                                </button>
                                            </div>
                                            <div class="box-btn" *ngIf="item.status !='Approved'">
                                                <button type="button" title="Approve" class="btn btn-info text-center" (click)="approve(item._id,3)">
                                                    Approve
                                                </button>
                                            </div>
                                        </td>
                                    </tr>

                                </tbody>
                                <tbody *ngIf="dataListing.length ==0">
                                    <tr>
                                        <p class="text-center">Sorry, No Record Found</p>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="pagination-block pt-5">
                                <pagination-controls [previousLabel]="previousLabel" [nextLabel]="nextLabel" (pageChange)="getDetail((p = $event))" class="text-center" *ngIf="dataListing.length > 0"></pagination-controls>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12" *ngIf="CurrentUrl=='/feedback'">
                    <div class="card">
                        <div class="card-body  table-responsive">
                            <table class="table mb-0 table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">No.</th>
                                        <th scope="col">Image</th>
                                        <th scope="col">User Name</th>
                                        <th scope="col">Links</th>
                                        <th scope="col">Post</th>
                                        <th scope="col">Title</th>
                                        <th scope="col">Description</th>
                                        <th scope="col">Create Date</th>
                                    </tr>
                                </thead>
                                <tbody *ngIf="dataListing.length !=0">
                                    <tr *ngFor="let item of dataListing | paginate: { itemsPerPage: pageLimit, currentPage: p, totalItems: totalCount}; let i = index ">
                                        <td scope="row">{{(pageLimit * (p - 1)) + i + 1 }}</td>
                                        <td><img [src]="item.userData.image" style="height: 30px; width:30px"></td>
                                        <td>{{item.userData.fullName}}</td>
                                        <td>{{item.userData.totalLinks}}</td>
                                        <td>{{item.userData.totalPosts}}</td>
                                        <td>{{item.title}}</td>
                                        <td>{{item.description}}</td>
                                        <td>{{service.dateCon(item.createdAt)}}</td>
                                    </tr>

                                </tbody>
                                <tbody *ngIf="dataListing.length ==0">
                                    <tr>
                                        <p class="text-center">Sorry, No Record Found</p>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="pagination-block pt-5">
                                <pagination-controls [previousLabel]="previousLabel" [nextLabel]="nextLabel" (pageChange)="getDetail((p = $event))" class="text-center" *ngIf="dataListing.length > 0"></pagination-controls>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--end row-->





        </div>
    </div>
    <app-footer></app-footer>
</div>

<div class="modal fade" id="Image_view1" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="qr-modal modal-dialog modal-dialog-centered">
        <div class="modal-content darksecundary-bg border-radius20">
            <div class="modal-body" id="thankyou-page-block">
                <div class="btn-box pt-2 text-end">
                    <a class="font-16" href="javascript:void(0);" (click)="close('#Image_view1')" class="close" data-dismiss="modal" title="Close"><i class='bx bx-x'></i></a>
                </div>
                <div class="px-3 pb-4 text-center">
                    <div class="mt-4 p-4 white-bg qr-code-img">
                        <img id="qr_code" loading="lazy" class="w-100" [src]="largeView" />
                    </div>
                </div>

            </div>

        </div>
    </div>
</div>

<div class="modal fade" id="Video_view1" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="qr-modal modal-dialog modal-dialog-centered">
        <div class="modal-content darksecundary-bg border-radius20">
            <div class="modal-body" id="thankyou-page-block">
                <div class="btn-box pt-2 text-end">
                    <a class="font-16" href="javascript:void(0);" (click)="close('#Video_view1')" class="close" data-dismiss="modal" title="Close"><i class='bx bx-x'></i></a>
                </div>
                <div class="px-3 pb-4 text-center">
                    <div class="file-upload-output">
                        <video [src]="largeView" class="w-100"  controls disablePictureInPicture controlsList="noplaybackrate nodownload" type="video/*"></video>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>